import { styled as s } from "@mui/system";
const e = s;
export {
  e as s
};
